export default __webpack_public_path__ + "static/media/bodycard5.2f8c2271.png";